import React, { useState } from "react";
//@ts-ignore
import { db } from "../../utils/firebase";
import { doc, setDoc } from "firebase/firestore";
import { toast } from "react-toastify";

interface BlogForm {
  title: string;
  slug: string;
  excerpt: string;
  author: string;
  coverImage: string;
  ogImage: string;
  tags: string;
  content: string;
  readingTime: number;
}

const BlogAdmin: React.FC = () => {
  const [formData, setFormData] = useState<BlogForm>({
    title: "",
    slug: "",
    excerpt: "",
    author: "Zafflo Team",
    coverImage: "",
    ogImage: "",
    tags: "",
    content: "",
    readingTime: 3,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.slug.trim()) {
      toast.error("Slug is required!");
      return;
    }

    setLoading(true);
    try {
      const docRef = doc(db, "blogs", formData.slug);

      await setDoc(docRef, {
        title: formData.title,
        excerpt: formData.excerpt,
        author: formData.author,
        date: new Date().toISOString(),
        coverImage: formData.coverImage,
        ogImage: formData.ogImage,
        tags: formData.tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean),
        published: true,
        content: formData.content,
        readingTime: Number(formData.readingTime) || 3,
      });

      toast.success("✅ Blog posted successfully!");
      setFormData({
        title: "",
        slug: "",
        excerpt: "",
        author: "Zafflo Team",
        coverImage: "",
        ogImage: "",
        tags: "",
        content: "",
        readingTime: 3,
      });
    } catch (err) {
      console.error("Error posting blog:", err);
      toast.error("❌ Failed to post blog!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h2 className="text-2xl font-semibold mb-6 text-gray-800">
        ✍️ Add New Blog
      </h2>

      <form onSubmit={handleSubmit} className="space-y-5">
        <input
          type="text"
          name="title"
          placeholder="Blog Title"
          value={formData.title}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          required
        />

        <input
          type="text"
          name="slug"
          placeholder="Slug (e.g. whatsapp-menus-future)"
          value={formData.slug}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          required
        />

        <textarea
          name="excerpt"
          placeholder="Short description / Excerpt"
          value={formData.excerpt}
          onChange={handleChange}
          className="w-full border p-2 rounded"
          rows={2}
        />

        <input
          type="text"
          name="coverImage"
          placeholder="Cover Image URL"
          value={formData.coverImage}
          onChange={handleChange}
          className="w-full border p-2 rounded"
        />

        <input
          type="text"
          name="ogImage"
          placeholder="OG Image URL"
          value={formData.ogImage}
          onChange={handleChange}
          className="w-full border p-2 rounded"
        />

        <input
          type="text"
          name="tags"
          placeholder="Tags (comma separated)"
          value={formData.tags}
          onChange={handleChange}
          className="w-full border p-2 rounded"
        />

        <input
          type="number"
          name="readingTime"
          placeholder="Reading Time (minutes)"
          value={formData.readingTime}
          onChange={handleChange}
          className="w-full border p-2 rounded"
        />

        <textarea
          name="content"
          placeholder="Blog HTML Content"
          value={formData.content}
          onChange={handleChange}
          className="w-full border p-2 rounded h-40"
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded w-full"
        >
          {loading ? "Publishing..." : "Publish Blog"}
        </button>
      </form>
    </div>
  );
};

export default BlogAdmin;
